import { useGame } from "@/hooks/useGame"
import { useGameMoves } from "@/hooks/useGameMoves"
import { Switch } from "@headlessui/react"
import clsx from "clsx"
import Move from "./Move"

const Analysis = () => {
  const { analysis, isAnalyzing, analyze, setAnalyze } = useGame()
  const { addMoves } = useGameMoves()

  const handleSuggestionClick = (index: number) => {
    if (!analysis?.moves) return
    const newMoves = analysis.moves.slice(0, index + 1)
    addMoves(newMoves)
  }

  return (
    <div className="border-b border-gray-200 pb-4">
      <div className="flex items-center justify-between">
        <div className="text-chessdrop-500 text-sm font-medium tracking-tight uppercase">
          Computer analysis
        </div>
        <Switch
          checked={analyze}
          onChange={setAnalyze}
          className={clsx(
            analyze ? "bg-green-600" : "bg-gray-200",
            "relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:ring-2 focus:ring-green-600 focus:ring-offset-2 focus:outline-none"
          )}
        >
          <span className="sr-only">Toggle computer analysis</span>
          <span
            aria-hidden="true"
            className={clsx(
              analyze ? "translate-x-5" : "translate-x-0",
              "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
            )}
          />
        </Switch>
      </div>
      {analyze && (
        <div className="grid grid-cols-4 items-center gap-x-1.5 pt-4">
          {analysis ? (
            <>
              {analysis.score ? (
                <div
                  className={clsx(
                    "relative flex h-9 items-center justify-center rounded-xl border px-4 text-sm font-semibold",
                    analysis.advantage === "w"
                      ? "border-gray-200 bg-white text-gray-900"
                      : "border-gray-800 bg-gray-800 text-white"
                  )}
                >
                  <span>{analysis.score}</span>
                  {isAnalyzing && (
                    <div className="pulse bg-chessdrop-500 absolute top-2 right-2 h-1 w-1 rounded-full" />
                  )}
                </div>
              ) : null}
              {Array.isArray(analysis.moves)
                ? analysis.moves
                    .slice(0, 3)
                    .map((move, index) => (
                      <Move
                        key={move.san + move.after}
                        move={move}
                        active={false}
                        position={[]}
                        disabled={isAnalyzing}
                        onClick={() => handleSuggestionClick(index)}
                      />
                    ))
                : null}
            </>
          ) : (
            [1, 2, 3, 4].map((number) => (
              <div key={number} className="h-9 rounded-xl bg-gray-100" />
            ))
          )}
        </div>
      )}
    </div>
  )
}

export default Analysis
